var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editPen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 149",
    d: "M9.48242 4.16016L12.1345 6.7649",
    stroke: "#026094",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 150",
    d: "M4.77456 13.5607L4.77454 11.5462L2.76632 11.546",
    stroke: "#026094",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 184",
    d: "M1.65719 14.6374L2.11039 11.3369L11.9036 1.54353L14.751 4.391L4.95782 14.1844L1.65719 14.6374Z",
    stroke: "#026094"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 995"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_7120_34464",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0181 3.94834C15.1953 3.77033 15.3356 3.55917 15.4312 3.32691C15.5268 3.09465 15.5757 2.84584 15.5751 2.59469C15.5745 2.34354 15.5244 2.09497 15.4278 1.86316C15.3311 1.63135 15.1897 1.42085 15.0117 1.24368C14.8337 1.06651 14.6226 0.926131 14.3903 0.830565C14.1581 0.735 13.9093 0.686117 13.6581 0.686708C13.407 0.687299 13.1584 0.737352 12.9266 0.834009C12.6948 0.930667 12.4843 1.07204 12.3071 1.25004L12.7302 1.67118C12.8521 1.54873 12.9969 1.45149 13.1563 1.38501C13.3158 1.31852 13.4868 1.28409 13.6595 1.28369C13.8323 1.28328 14.0034 1.3169 14.1632 1.38264C14.3229 1.44837 14.4682 1.54493 14.5906 1.6668C14.7131 1.78867 14.8103 1.93346 14.8768 2.09291C14.9433 2.25236 14.9777 2.42334 14.9781 2.5961C14.9785 2.76885 14.9449 2.94 14.8791 3.09976C14.8134 3.25952 14.7169 3.40476 14.595 3.52721L15.0181 3.94834Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0181 3.94834C15.1953 3.77033 15.3356 3.55917 15.4312 3.32691C15.5268 3.09465 15.5757 2.84584 15.5751 2.59469C15.5745 2.34354 15.5244 2.09497 15.4278 1.86316C15.3311 1.63135 15.1897 1.42085 15.0117 1.24368C14.8337 1.06651 14.6226 0.926131 14.3903 0.830565C14.1581 0.735 13.9093 0.686117 13.6581 0.686708C13.407 0.687299 13.1584 0.737352 12.9266 0.834009C12.6948 0.930667 12.4843 1.07204 12.3071 1.25004L12.7302 1.67118C12.8521 1.54873 12.9969 1.45149 13.1563 1.38501C13.3158 1.31852 13.4868 1.28409 13.6595 1.28369C13.8323 1.28328 14.0034 1.3169 14.1632 1.38264C14.3229 1.44837 14.4682 1.54493 14.5906 1.6668C14.7131 1.78867 14.8103 1.93346 14.8768 2.09291C14.9433 2.25236 14.9777 2.42334 14.9781 2.5961C14.9785 2.76885 14.9449 2.94 14.8791 3.09976C14.8134 3.25952 14.7169 3.40476 14.595 3.52721L15.0181 3.94834Z",
    stroke: "#026094",
    strokeWidth: 2,
    mask: "url(#path-4-inside-1_7120_34464)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/editPen.d5c6e9dbda9cb8332cfa5e234d69416d.svg";
export { ForwardRef as ReactComponent };